<script lang="ts">
  import {browser$} from '@/streams/browser';
  import {createEventDispatcher, onMount} from 'svelte';

  export let direction: 'left' | 'right' = 'right';
  export let customHeader = false;
  export let autoCloseDrawer = false;
  export let visible = false;

  const dispatch = createEventDispatcher();
  const className = '--body-hidden';

  let bodyElement;

  $: browser$ && updateBodyStyle(visible);

  onMount(() => {
    requestAnimationFrame(() => {
      visible = true;
    });
  });

  function updateBodyStyle(visible) {
    if (!bodyElement) {
      bodyElement = document.body;
    }
    if (visible) {
      setTimeout(() => {
        bodyElement.classList.add(className);
      }, 100);
      return;
    }
    bodyElement.classList.remove(className);
  }

  function handleCloseClickEvent() {
    visible = false;
    const timer = setTimeout(() => {
      dispatch('close');
      clearTimeout(timer);
    }, 300);
  }

  function handleMaskClick() {
    if (autoCloseDrawer) {
      handleCloseClickEvent();
    }
  }
</script>

<style lang="scss">
  .drawer-wrap {
    z-index: 999;
  }
  .drawer-wrap,
  .drawer-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  .drawer-mask {
    background: rgba(0, 0, 0, 0.6);
  }
  .drawer-main {
    position: fixed;
    top: 0;
    box-sizing: border-box;
    padding: 0 32px;
    max-width: 100vw;
    height: 100vh;
    overflow-y: auto;
    transition: transform 300ms ease 0ms;
    will-change: transfrom;
    &::-webkit-scrollbar {
      display: none;
    }
    &.left {
      left: 0;
      transform: translateX(-100%);
    }
    &.right {
      right: 0;
      transform: translateX(100%);
    }
    &.visible {
      transform: translateX(0);
    }
  }
  .drawer-header {
    min-height: 120px;
  }
  .drawer-wrap {
    &.clean {
      .drawer-main {
        padding: 0;
      }
    }
  }
  .drawer-close-box {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    background: #eff2f7;
    &:hover {
      opacity: 0.8;
    }
  }
  .close-icon {
    color: #a7abb3;
  }
  // :global(.--body-hidden) {
  //   overflow: hidden !important;
  // }
</style>

<div class="drawer-wrap" class:clean={customHeader}>
  <div class="drawer-mask" on:click={handleMaskClick} />
  <div class="drawer-main B1 {direction}" class:visible on:transitionend>
    {#if !customHeader}
      <div class="drawer-header df aic jcsb">
        <div><slot name="header" /></div>
        <div class="drawer-close-box df aic jcc cp" on:click={handleCloseClickEvent}>
          <i class="close-icon iconfont f24">&#xe614;</i>
        </div>
      </div>
    {/if}

    <div class="drawer-body">
      <slot />
    </div>
  </div>
</div>
